import * as c from '../constants/webSettings';
import { RESET_ALL_STORE } from '../constants/user';

const initialState = {
  settings: {}, // Web設定のオブジェクト
  error: null,
};

export default function webSettings(state = initialState, action) {
  switch (action.type) {
    case c.GET_WEB_SETTINGS:
      if (action.error) {
        return {
          ...state,
          error: action.payload.message,
        };
      }
      return {
        ...state,
        settings: action.payload.settings,
      };

    // すべてリセットする
    case RESET_ALL_STORE:
      return initialState;

    default:
      return state;
  }
}
